import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonTypeEnum } from '../button/button-type.enum';

@Component({
  selector: 'app-text-button',
  templateUrl: './text-button.component.html',
  styleUrls: ['./text-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextButtonComponent {
  @Input() type: ButtonTypeEnum = ButtonTypeEnum.primary;
  @Input() size: 'default' | 'small' = 'default';
  @Input() disabled: boolean = false;
  @Output() buttonClicked = new EventEmitter<void>();
}
